
export const titoloLavoraComeAssistente = 'LAVORARE COME \nASSISTENTE FAMILIARE ';
export const emailDescription = 'Per candidarti a uno dei servizi presenti sulla\npiattaforma invia il tuo Curriculum alla mail\n';
export const emailDescription2 = '\nspecificando i servizi per cui ti vuoi offrire';
